import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type {
  BrowserNames,
  Error
} from '@eggplant/types'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: BrowserNames[]) => void
  children?: (response: BrowserNames[]) => ReactElement
  shortErrorMessage?: string
  dataCenter: string
  platform: string
}

const GetSauceLabsBrowserNames = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children,
  dataCenter,
  platform
}: Props) => {
  const url = `${SUT_SERVICE}/sauce_labs/data_centers/${dataCenter}/browser_platforms/${platform}/browsers`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetSauceLabsBrowserNames
